export function getItem(key) {
    let item;
    try {
        item = JSON.parse(window.localStorage.getItem(key) || "");
    }
    catch (e) {
        try {
            item = window.localStorage.getItem(key) || null;
        }
        catch (ee) {
            item = null;
        }
    }
    return item;
}
export function setItem(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
    catch (e) {
        console.error("Unable to save new localStorage value", e);
    }
}
export function removeItem(key) {
    try {
        window.localStorage.removeItem(key);
    }
    catch (e) {
        console.error("Unable to remove localStorage item", e);
    }
}
